<template>
  <div class="d-flex flex-column w-100 nb-dashboard-container" v-if="showDashboardVendas">
    <!-- BARRA DE NAVEGAÇÃO POR ABAS (ESTILO STITCH) -->
    <div class="nb-tab-navigation-wrapper mb-4">
      <div class="nb-tab-navigation">
        <button
          v-if="idxPainelPedido !== null"
          type="button"
          class="nb-tab-btn"
          :class="{ active: showTabPedido }"
          @click="changeTab(idxPainelPedido)"
        >
          <i class="fa fa-line-chart mr-2"></i>
          <span>Painel de Vendas &amp; Pedidos</span>
        </button>

        <button
          v-if="idxPainelNfe !== null && (appNFe || appERP)"
          type="button"
          class="nb-tab-btn"
          :class="{ active: showTabNFe }"
          @click="changeTab(idxPainelNfe)"
        >
          <i class="fa fa-file-text-o mr-2"></i>
          <span>Faturamento &amp; NF-e</span>
        </button>

        <button
          v-if="idxPainelVarejo !== null"
          type="button"
          class="nb-tab-btn"
          :class="{ active: showTabVarejo }"
          @click="changeTab(idxPainelVarejo)"
        >
          <i class="fa fa-shopping-basket mr-2"></i>
          <span>Frente de Caixa &amp; Varejo</span>
        </button>

        <button
          v-if="idxPainelGuiaNfe !== null || idxPainelGuiaForcaVendas !== null"
          type="button"
          class="nb-tab-btn"
          :class="{ active: showTabGuiaNFe || showTabGuiaForcaVendas }"
          @click="changeTab(idxPainelGuiaNfe !== null ? idxPainelGuiaNfe : idxPainelGuiaForcaVendas)"
        >
          <i class="fa fa-rocket mr-2"></i>
          <span>Guia Primeiros Passos</span>
          <span class="nb-tab-badge ml-2" :class="{ 'badge-complete': guiaProgresso.completed === guiaProgresso.total }">
            {{ guiaProgresso.completed }}/{{ guiaProgresso.total }} concluído
          </span>
        </button>
      </div>
    </div>

    <!-- TOOLBAR GLOBAL DE FILTROS & AÇÕES RÁPIDAS (ESTILO STITCH) -->
    <div class="nb-toolbar-card mb-4" v-if="!showTabGuiaNFe && !showTabGuiaForcaVendas">
      <div class="row align-items-center">
        <!-- SELETOR DE MÊS/PERÍODO -->
        <div class="col-xl-3 col-lg-4 col-md-5 col-12 mb-2 mb-md-0 d-flex align-items-center">
          <div class="w-100" style="min-width: 145px;">
            <input-month
              :p-month="filter"
              :show-options="false"
              @monthChange="handleMonthChange"
            ></input-month>
          </div>
        </div>

        <!-- SELETORES DE USUÁRIO E FILIAL -->
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-12 mb-2 mb-md-0 d-flex align-items-center"
          v-if="showTabPedido"
        >
          <div class="w-100 mr-2" v-if="usuarioList && usuarioList.length > 0">
            <form-field
              v-model="codusuario"
              type="select"
              col="12"
              :select-options="usuarioList"
              placeholder="Todos os Vendedores"
            ></form-field>
          </div>
        </div>

        <!-- AÇÕES RÁPIDAS & ATALHOS DE CRIAÇÃO -->
        <div
          :class="showTabPedido ? 'col-xl-5 col-lg-4' : 'col-xl-9 col-lg-8'"
          class="col-md-12 col-12 d-flex align-items-center justify-content-md-end flex-wrap gap-2"
        >
          <!-- DROPDOWN DE CONSULTAS / AÇÕES RÁPIDAS -->
          <div class="dropdown mr-2" v-if="!isRepresentante">
            <button
              class="btn nb-btn-secondary dropdown-toggle"
              type="button"
              id="dropdownConsultas"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fa fa-bolt text-warning mr-1"></i> Consultas
            </button>
            <div class="dropdown-menu dropdown-menu-right nb-megamenu shadow-lg" aria-labelledby="dropdownConsultas">
              <div class="row px-3 py-2">
                <div class="col-md-6 col-12 mb-2">
                  <div class="nb-menu-category">CLIENTES</div>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/carteiraclientes')">
                    <i class="fa fa-users mr-1"></i> Carteira de Clientes
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas-performance-carteira')">
                    <i class="fa fa-line-chart mr-1"></i> Performance Carteira
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/curvacliente')">
                    <i class="fa fa-pie-chart mr-1"></i> Curva ABC de Clientes
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas-por-cliente')">
                    <i class="fa fa-user mr-1"></i> Vendas por Cliente
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/lista-clientes')">
                    <i class="fa fa-list mr-1"></i> Listagem de Clientes
                  </a>

                  <div class="nb-menu-category mt-3">VENDEDORES</div>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas-vendedor')">
                    <i class="fa fa-trophy mr-1"></i> Ranking de Vendedores
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas')">
                    <i class="fa fa-search mr-1"></i> Consulta Vendas
                  </a>
                </div>

                <div class="col-md-6 col-12 mb-2">
                  <div class="nb-menu-category">PRODUTOS &amp; ESTOQUE</div>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas-produtos')">
                    <i class="fa fa-tag mr-1"></i> Produtos Vendidos
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/entrada-e-saida')">
                    <i class="fa fa-exchange mr-1"></i> Movimentação (E/S)
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/resumo-entrada-e-saida')">
                    <i class="fa fa-bar-chart mr-1"></i> Resumo Movimentação
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/estoque-saldo')">
                    <i class="fa fa-cubes mr-1"></i> Saldo em Estoque
                  </a>

                  <div class="nb-menu-category mt-3">PEDIDOS</div>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas-pedidos-produto')">
                    <i class="fa fa-shopping-cart mr-1"></i> Pedidos por Produto
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas-pedidos-faturados')">
                    <i class="fa fa-check mr-1"></i> Pedidos Faturados
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas-pedidos-comissao-por-pedido')">
                    <i class="fa fa-percent mr-1"></i> Comissão por Pedido
                  </a>
                  <a class="dropdown-item nb-menu-item" href="javascript:void(0);" @click="clickConsulta('/consultas/vendas-pedido-recebimentos')">
                    <i class="fa fa-credit-card mr-1"></i> Recebimentos Cartão
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- BOTÕES DE CRIAÇÃO RÁPIDA -->
          <button
            type="button"
            class="btn nb-btn-primary mr-1"
            @click="handleNovoPedido"
            title="Criar novo pedido"
          >
            <i class="fa fa-plus mr-1"></i> Novo Pedido
          </button>
          <button
            v-if="showBtnEmitirNfe"
            type="button"
            class="btn nb-btn-success"
            @click="clickConsulta('/nf/novo')"
            title="Emitir nova NF-e"
          >
            <i class="fa fa-file-text mr-1"></i> Emitir NF-e
          </button>
        </div>
      </div>
    </div>

    <!-- ABA 1: DASHBOARD PEDIDOS/VENDAS -->
    <div
      v-if="showTabPedido && showDashboardVendas"
      class="w-100"
      :class="!hasGuiaUnchecked || !guia ? 'order-0' : 'order-1'"
    >
      <div class="row">
        <!-- KPIs Principais -->
        <dash-card
          :params="dashboard.items[1]"
          :filter="filter"
          @clickbutton="handleClickCard"
        ></dash-card>
        <!-- Evolução de Vendas -->
        <dash-card
          :params="dashboard.items[0]"
          :filter="filter"
          @clickbutton="handleClickCard"
        ></dash-card>
        <!-- Gráficos de Carteira & Clientes -->
        <dash-card
          :params="dashboard.items[2]"
          :filter="filter"
          @clickbutton="handleClickCard"
        ></dash-card>
        <dash-card
          :params="dashboard.items[3]"
          :filter="filter"
          @clickbutton="handleClickCard"
        ></dash-card>
        <dash-card
          :params="dashboard.items[4]"
          :filter="filter"
          @clickbutton="handleClickCard"
        ></dash-card>
        <!-- Histórico 12 Meses -->
        <dash-card
          :params="dashboard.items[5]"
          :filter="filter"
          @clickbutton="handleClickCard"
        ></dash-card>
      </div>
    </div>

    <!-- ABA 2: GUIA DE AJUDA / ONBOARDING NF-E -->
    <div
      v-if="showTabGuiaNFe"
      :class="hasGuiaUnchecked && guia ? 'order-0' : 'order-1'"
    >
      <dashboard-guia-nfe></dashboard-guia-nfe>
    </div>

    <!-- ABA GUIA DE AJUDA / ONBOARDING FORÇA DE VENDAS -->
    <div
      v-if="showTabGuiaForcaVendas"
      :class="hasGuiaUnchecked && guia ? 'order-0' : 'order-1'"
    >
      <dashboard-guia-forcavendas></dashboard-guia-forcavendas>
    </div>

    <!-- ABA 3: DASHBOARD NF-E / FATURAMENTO -->
    <div v-if="showTabNFe && (appNFe || appERP)">
      <dashboard-nfe :filter-prop="filter"></dashboard-nfe>
    </div>

    <!-- ABA 4: DASHBOARD VAREJO / PDV -->
    <div v-if="showTabVarejo">
      <dashboard-varejo :filter-prop="filter"></dashboard-varejo>
    </div>
  </div>
</template>

<script>
import DashCard from "./dash-card";
import DashboardGuiaNfe from "./dashboard-guia-nfe.vue";
import DashboardGuiaForcavendas from "./dashboard-guia-forcavendas.vue";
import DashboardNfe from "./dashboard-nfe.vue";
import DashboardVarejo from "./dashboard-varejo.vue";
import { SysVars } from "../main";
import moment from "moment";

export default {
  components: {
    DashCard,
    DashboardGuiaNfe,
    DashboardGuiaForcavendas,
    DashboardNfe,
    DashboardVarejo,
  },

  data() {
    return {
      tabs: [],
      guiaNfe: [
        { completed: true },
        { completed: true },
        { completed: false },
        { completed: false },
        { completed: false },
        { completed: false }
      ],
      idxPainelGuiaForcaVendas: null,
      idxPainelGuiaNfe: null,
      idxPainelNfe: null,
      idxPainelPedido: null,
      idxPainelVarejo: null,

      showDashboardVendas: false,
      showInicio: false,

      filter: {
        startDate: null,
        endDate: null,
        codusuario: null
      },

      activeTab: 0,
      hasGuiaUnchecked: false,
      codusuario: null,

      dashboard: {
        items: [
          {
            name: "evolucaovendas",
            chart: { type: "LineChart" },
            col: 12,
            detalhes: { url: "/consultas/vendas-vendedor" }
          },
          { name: "DASH_VENDAS_PEDIDO", indicator: {}, col: 12 },
          {
            name: "performancecarteira",
            chart: { type: "PieChart" },
            col: 4,
            detalhes: { url: "/consultas/vendas-performance-carteira" }
          },
          {
            name: "carteiraclientes",
            chart: { type: "PieChart" },
            col: 4,
            detalhes: { url: "/consultas/carteiraclientes" }
          },
          {
            name: "curvaclientes",
            chart: { type: "PieChart" },
            col: 4,
            detalhes: { url: "/consultas/curvacliente" }
          },
          {
            name: "vendas12meses",
            chart: { type: "ColumnChart" },
            col: 12,
            detalhes: { url: "/consultas/vendas" }
          }
        ]
      }
    };
  },

  watch: {
    codusuario: function() {
      this.filter.codusuario = this.codusuario;
      this.filter = { ...this.filter };
      this.updateQuery();
    }
  },

  methods: {
    checkHasGuiaUnchecked(value) {
      let hasUnchecked = false;
      value.map(item => (item.completed == false ? (hasUnchecked = true) : ""));
      return (this.hasGuiaUnchecked = hasUnchecked);
    },

    updateQuery() {
      const params = new URLSearchParams();
      if (this.filter.startDate) params.set("data_inicio", this.filter.startDate);
      if (this.filter.endDate) params.set("data_termino", this.filter.endDate);
      if (this.codusuario) params.set("usuario", this.codusuario);

      const queryString = params.toString();
      const newUrl = `${window.location.pathname}${queryString ? '?' + queryString : ''}`;
      window.history.replaceState(window.history.state, '', newUrl);
    },

    changeTab(idx) {
      switch (idx) {
        case this.idxPainelGuiaNfe:
          this.$router.push("/guianfe");
          break;
        case this.idxPainelGuiaForcaVendas:
          this.$router.push("/guiapedidos");
          break;
        case this.idxPainelNfe:
          this.$router.push("/painelnfe");
          break;
        case this.idxPainelVarejo:
          this.$router.push("/painelvarejo");
          break;
        case this.idxPainelPedido:
          this.$router.push("/painelpedidos");
          break;
      }
    },

    adquireCert() {
      this.$router.push("https://notabrasil.com.br/certificado-digital");
    },

    clickConsulta(url) {
      this.$router.push(url);
    },

    handleNovoPedido() {
      if (this.isContextoForcaVendas) {
        this.$router.push('/fv/pedidos');
      } else {
        this.clickConsulta('/pedido/novo');
      }
    },

    handleMonthChange() {
      this.filter = { ...this.filter };
      this.updateQuery();
    },

    handleClickCard(idx) {},

    async loadGuiaNfe() {
      await this.$store.dispatch("loadGuiaNFe", this);

      this.guiaNfe[0].completed = this.dadosGuia.empresa;
      const hasCertSessao = Boolean(this.sessao && Array.isArray(this.sessao.certificado) && this.sessao.certificado.length > 0);
      this.guiaNfe[1].completed = Boolean(this.dadosGuia.certificado || hasCertSessao);
      this.guiaNfe[2].completed = this.dadosGuia.item;
      this.guiaNfe[3].completed = this.dadosGuia.cliente;
      this.guiaNfe[4].completed = !!(this.dadosGuia.pedido || this.dadosGuia.varejo);
      this.guiaNfe[5].completed = this.dadosGuia.nf;

      if (SysVars.appForcaVendas) {
        this.hasGuiaUnchecked = !(
          this.dadosGuia.empresa &&
          this.dadosGuia.item &&
          this.dadosGuia.cliente &&
          (this.dadosGuia.pedido || this.dadosGuia.varejo)
        );
      } else {
        this.checkHasGuiaUnchecked(this.guiaNfe);
      }
    },

    resolveHomeTab() {
      if (SysVars.appForcaVendas) {
        if (SysVars.guia && this.hasGuiaUnchecked && this.idxPainelGuiaForcaVendas !== null) {
          this.activeTab = this.idxPainelGuiaForcaVendas;
        } else if (this.idxPainelPedido !== null) {
          this.activeTab = this.idxPainelPedido;
        } else {
          this.activeTab = this.tabs.length > 0 ? 0 : null;
        }
      } else if (SysVars.guia) {
        this.activeTab = this.idxPainelGuiaNfe;
      } else {
        // ELSE DO SYSVARS.GUIA:
        // 1. Se existem registros na tabela nf, exibir painelnfe
        if (this.dadosGuia.nf && this.idxPainelNfe !== null) {
          this.activeTab = this.idxPainelNfe;
        // 2. Se existem registros na tabela pedv (tipo pedido), exibir painelPedido
        } else if (this.dadosGuia.pedido && this.idxPainelPedido !== null) {
          this.activeTab = this.idxPainelPedido;
        // 3. Se existem registros na tabela pedv (tipo pedido varejo), exibir painelVarejo
        } else if (this.dadosGuia.varejo && this.idxPainelVarejo !== null) {
          this.activeTab = this.idxPainelVarejo;
        } else {
          // Fallback se não houver registros nas tabelas
          if (this.idxPainelNfe !== null && SysVars.appNFe) {
            this.activeTab = this.idxPainelNfe;
          } else if (this.idxPainelPedido !== null) {
            this.activeTab = this.idxPainelPedido;
          } else if (this.idxPainelVarejo !== null) {
            this.activeTab = this.idxPainelVarejo;
          } else {
            this.activeTab = this.tabs.length > 0 ? 0 : null;
          }
        }
      }
    },

    async loadData() {
      await this.$store.dispatch("loadSessao", this);
      await this.$store.dispatch("loadUsuariosDashboard", this);
      await this.$store.dispatch("loadFilial", {});
      await this.loadGuiaNfe();
      if (this.$route.name === "home") {
        this.resolveHomeTab();
      }
      this.showDashboardVendas = true;
    }
  },

  computed: {
    dadosGuia: function() {
      return this.$store.getters.getGuiaNFe || {};
    },

    guiaProgresso: function() {
      if (SysVars.appForcaVendas) {
        let completed = 0;
        if (this.dadosGuia.empresa) completed++;
        if (this.dadosGuia.item) completed++;
        if (this.dadosGuia.cliente) completed++;
        if (this.dadosGuia.pedido || this.dadosGuia.varejo) completed++;
        return {
          completed: completed,
          total: 4,
          percent: Math.round((completed / 4) * 100)
        };
      }
      const completed = this.guiaNfe.filter(item => item.completed).length;
      return {
        completed: completed,
        total: 6,
        percent: Math.round((completed / 6) * 100)
      };
    },

    showTabPedido: function() {
      return this.activeTab == this.idxPainelPedido;
    },

    showTabGuiaNFe: function() {
      return this.activeTab == this.idxPainelGuiaNfe;
    },

    showTabGuiaForcaVendas: function() {
      return this.activeTab == this.idxPainelGuiaForcaVendas;
    },

    showTabNFe: function() {
      return this.activeTab == this.idxPainelNfe;
    },

    showTabVarejo: function() {
      return this.activeTab == this.idxPainelVarejo;
    },

    sessao: function() {
      return this.$store.getters.getSessao;
    },

    usuarioList: function() {
      let options = [];
      const list = this.$store.getters.getUsuarioList || [];
      for (var x = 0; x < list.length; x++) {
        options.push({
          id: list[x].codusuario,
          text: list[x].nome
        });
      }
      return options;
    },

    appNFe: function() {
      return SysVars.appNFe;
    },

    appERP: function() {
      return SysVars.appERP;
    },

    appForcaVendas: function() {
      return SysVars.appForcaVendas;
    },

    isContextoForcaVendas: function() {
      return !!(SysVars.usuarioForcaVendas || (this.appForcaVendas && !this.appERP && !this.appNFe));
    },

    showBtnEmitirNfe: function() {
      if (this.isContextoForcaVendas) return false;
      return !!(this.appNFe || this.appERP);
    },

    isAdmin: function() {
      return SysVars.usuarioAdministrador;
    },

    guia: function() {
      return SysVars.guia;
    },

    isRepresentante: function() {
      return !!(
        SysVars.usuarioForcaVendas ||
        (this.sessao && (this.sessao.perfil == 3 || this.sessao.perfil == '3'))
      );
    },
  },

  mounted() {
    this.tabs = [];
    if (SysVars.appERP) {
      this.tabs.push({ title: "Guia de Ajuda", icon: null });
      this.idxPainelGuiaNfe = this.tabs.length - 1;
      this.tabs.push({ title: "Painel de Pedidos", icon: null });
      this.idxPainelPedido = this.tabs.length - 1;
      this.tabs.push({ title: "Painel de Notas Fiscais", icon: null });
      this.idxPainelNfe = this.tabs.length - 1;
      this.tabs.push({ title: "Painel Varejo", icon: null });
      this.idxPainelVarejo = this.tabs.length - 1;
    } else if (SysVars.appForcaVendas) {
      this.tabs.push({ title: "Guia de Ajuda", icon: null });
      this.idxPainelGuiaForcaVendas = this.tabs.length - 1;
      this.tabs.push({ title: "Painel de Pedidos", icon: null });
      this.idxPainelPedido = this.tabs.length - 1;
    } else if (SysVars.appNFe) {
      this.tabs.push({ title: "Guia de Ajuda", icon: null });
      this.idxPainelGuiaNfe = this.tabs.length - 1;
      this.tabs.push({ title: "Painel de Notas Fiscais", icon: null });
      this.idxPainelNfe = this.tabs.length - 1;
    } else if (SysVars.appVarejo) {
      this.tabs.push({ title: "Painel Varejo", icon: null });
      this.idxPainelVarejo = this.tabs.length - 1;
    }

    switch (this.$route.name) {
      case "painelvarejo":
        this.activeTab = this.idxPainelVarejo;
        break;
      case "painelnfe":
        this.activeTab = this.idxPainelNfe;
        break;
      case "guianfe":
        this.activeTab = this.idxPainelGuiaNfe;
        break;
      case "guiapedidos":
        if (SysVars.appForcaVendas && this.idxPainelGuiaForcaVendas !== null) {
          this.activeTab = this.idxPainelGuiaForcaVendas;
        } else {
          this.activeTab = this.idxPainelPedido;
        }
        break;
      case "painelpedidos":
      case "pedido":
        this.activeTab = this.idxPainelPedido;
        break;
      case "home":
        this.resolveHomeTab();
        break;
      default:
        this.activeTab = this.idxPainelPedido;
        break;
    }

    if (this.$route.query.usuario) {
      this.codusuario = this.$route.query.usuario;
    }

    if (this.$route.query.data_inicio) {
      this.filter.startDate = this.$firstDay(this.$route.query.data_inicio);
      this.filter.endDate = this.$lastDay(this.$route.query.data_termino);
    }

    this.loadData().then(() => {
      if (this.hasGuiaUnchecked && this.guia && SysVars.primeiroAcesso) {
        SysVars.primeiroAcesso = false;
        if (SysVars.appForcaVendas) {
          this.changeTab(this.idxPainelGuiaForcaVendas);
        } else {
          this.changeTab(this.idxPainelGuiaNfe);
        }
      }
    });
  }
};
</script>

<style scoped>
.nb-dashboard-container {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0b1c30;
}

/* TAB NAVIGATION */
.nb-tab-navigation-wrapper {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.nb-tab-navigation {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.nb-tab-btn {
  background: transparent;
  border: none;
  outline: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 13.5px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s ease;
}

.nb-tab-btn:hover {
  background: #f8fafc;
  color: #0b1c30;
}

.nb-tab-btn.active {
  background: #004e94;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 78, 148, 0.25);
}

.nb-tab-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
  background: #eff4ff;
  color: #004e94;
}

.nb-tab-btn.active .nb-tab-badge {
  background: #ffffff;
  color: #004e94;
}

.nb-tab-badge.badge-complete {
  background: #ecfdf5;
  color: #059669;
}

/* TOOLBAR CARD */
.nb-toolbar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

/* BUTTONS */
.nb-btn-primary {
  background: #004e94;
  color: #ffffff;
  border: 1px solid #004e94;
  font-weight: 600;
  font-size: 13px;
  padding: 7px 14px;
  border-radius: 8px;
  transition: all 0.15s ease;
}

.nb-btn-primary:hover {
  background: #00376c;
  color: #ffffff;
}

.nb-btn-secondary {
  background: #f8fafc;
  color: #0b1c30;
  border: 1px solid #cbd5e1;
  font-weight: 600;
  font-size: 13px;
  padding: 7px 14px;
  border-radius: 8px;
}

.nb-btn-secondary:hover {
  background: #f1f5f9;
}

.nb-btn-success {
  background: #005a3c;
  color: #ffffff;
  border: 1px solid #005a3c;
  font-weight: 600;
  font-size: 13px;
  padding: 7px 14px;
  border-radius: 8px;
}

.nb-btn-success:hover {
  background: #00402a;
  color: #ffffff;
}

/* MEGAMENU / DROPDOWN */
.nb-megamenu {
  min-width: 480px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 12px;
}

.nb-menu-category {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #94a3b8;
  margin-bottom: 6px;
  padding-left: 8px;
}

.nb-menu-item {
  font-size: 12.5px;
  font-weight: 500;
  color: #1e293b;
  padding: 6px 10px;
  border-radius: 6px;
  transition: all 0.15s ease;
}

.nb-menu-item:hover {
  background: #eff4ff;
  color: #004e94;
}

@media (max-width: 768px) {
  .nb-megamenu {
    min-width: 290px;
  }
}
</style>




// WEBPACK FOOTER //
// src/dashboards/dashboard-form.vue